import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind classes with later ones winning.
 *
 * `clsx` flattens conditionals; `twMerge` resolves conflicts, which is the
 * half that matters: without it a component's own `px-4` and a caller's
 * `px-6` both land in the class list and the winner is whichever CSS rule
 * Tailwind emitted last — an outcome no reader of either file can predict.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
